module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-container-multiple"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_vm._v("示例一：")]), _vm._v(" "), _c('mt-layout-container-multiple', [_c('mt-layout-container-multiple-item', {
    staticClass: "mt-bg-primary",
    staticStyle: {
      "width": "33.33%"
    }
  }, [_vm._v("左(1/3)")]), _vm._v(" "), _c('mt-layout-container-multiple-item', {
    staticClass: "mt-bg-warning",
    staticStyle: {
      "width": "33.33%"
    }
  }, [_vm._v("中(1/3)")]), _vm._v(" "), _c('mt-layout-container-multiple-item', {
    staticClass: "mt-bg-danger",
    staticStyle: {
      "width": "33.33%"
    }
  }, [_vm._v("右(1/3)")])], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_vm._v("示例二：")]), _vm._v(" "), _c('mt-layout-container-multiple', {
    on: {
      "click": _vm.handleclick
    }
  }, [_c('mt-layout-container-multiple-item', {
    staticClass: "mt-bg-primary",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("10%")]), _vm._v(" "), _c('mt-layout-container-multiple-item', {
    staticClass: "mt-bg-warning",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("30%")]), _vm._v(" "), _c('mt-layout-container-multiple-item', {
    staticClass: "mt-bg-danger",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("10%")]), _vm._v(" "), _c('mt-layout-container-multiple-item', {
    staticClass: "mt-bg-green",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("40%")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afe98848","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/layout-container-multiple.vue
// module id = 557
// module chunks = 0